import { render, staticRenderFns } from "./ButtonSpinner.vue?vue&type=template&id=e2877022&scoped=true&"
import script from "./ButtonSpinner.vue?vue&type=script&lang=js&"
export * from "./ButtonSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2877022",
  null
  
)

export default component.exports